import type { InputHTMLAttributes, ReactNode } from "react";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  type?: string;
  fluid?: boolean;
  label?: string;
  labelColor?: string;
  defaultValue?: string;
  className?: string;
  rightElement?: ReactNode;
  leftElement?: ReactNode;
}

export default function Input({
  type = "text",
  fluid = false,
  label,
  labelColor = "white",
  defaultValue,
  className = "",
  rightElement = "",
  leftElement = "",
  ...props
}: Readonly<InputProps>) {
  const classes = [
    "px-3 py-2 text-white text-sm rounded-lg bg-input-dark focus:outline-none focus:ring-2 focus:ring-input-dark focus:border-input-dark transition-all",
    rightElement ? "pr-12" : "",
    leftElement ? "pl-12" : "",
    fluid ? "w-full" : "w-auto",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={`${fluid ? "w-full" : "inline-block"} py-1`}>
      {label && (
        <label className={`block mb-1 text-xs text-${labelColor}`}>
          {label}
        </label>
      )}
      <div className="relative">
        <input
          type={type}
          defaultValue={defaultValue}
          className={classes}
          {...props}
        />
        {rightElement && (
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-white text-sm pointer-events-none">
            {rightElement}
          </span>
        )}
        {leftElement && (
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-white text-sm pointer-events-none">
            {leftElement}
          </span>
        )}
      </div>
    </div>
  );
}
